import { defineMessages } from "react-intl";

export const messages = defineMessages({
    timeout: {
        id: "BxpUiSignup.nameSite.error.timeout",
        defaultMessage:
            "Something went wrong on our end. Please try again. If this keeps happening, <href-support>contact support</href-support>. (Issue ID for Atlassian use: {error_id})"
    },
    invalidName: {
        id: "BxpUiSignup.nameSite.error.invalidName",
        defaultMessage:
            "Your site name must be at least 3 characters long. Use only lowercase letters and numbers."
    },
    invalidWorkspaceName: {
        id: "BxpUiSignup.nameSite.error.invalidWorkspaceName",
        defaultMessage:
            "Your workspace name must be at least 3 characters long. Use only lowercase letters and numbers."
    },
    maxLength: {
        id: "BxpUiSignup.nameSite.error.maxLength",
        defaultMessage:
            "That's a bit too long — try something 50 characters or less."
    },
    unavailable: {
        id: "BxpUiSignup.nameSite.error.unavailable",
        defaultMessage: "This site is already taken."
    },
    unavailableWorkspace: {
        id: "BxpUiSignup.nameSite.error.unavailableWorkspace",
        defaultMessage: "This workspace name is already taken."
    },
    networkError: {
        id: "BxpUiSignup.nameSite.error.networkError",
        defaultMessage: "Something went wrong. Please try again later."
    }
});
